import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { Link, Outlet, useLoaderData, useParams } from "react-router-dom";

import { getLooking } from "../../lib/api";
import { IAPIResponse, ILookingForPlayers } from "../../types/api";

export const loader = async () => {
    return {
        looking: await getLooking(),
    };
};

const LookingForPlayers = (): React.JSX.Element | undefined => {
    const params = useParams();
    const {
        looking: { looking: loadedList },
    } = useLoaderData() as {
        looking: IAPIResponse & { looking: ILookingForPlayers[] };
    };

    const [lookingList, setLookingList] =
        useState<ILookingForPlayers[]>(loadedList);

    return !params.teamId ? (
        <div
            className="lookingForPlayersContent"
            data-testid="lookingForPlayersContent"
        >
            <Table striped responsive>
                <thead>
                    <tr>
                        <th></th>
                        <th>Team/Organization</th>
                        <th>Age</th>
                        <th>Position</th>
                        <th>Description</th>
                        <th>Contact Info</th>
                    </tr>
                </thead>
                <tbody>
                    {lookingList
                        .sort((a, b) => {
                            const aAge = a.age ? parseInt(a.age[0]) : 0;
                            const bAge = b.age ? parseInt(b.age[0]) : 0;
                            const ageCheck = aAge - bAge;

                            return ageCheck !== 0
                                ? ageCheck
                                : a.team.localeCompare(b.team);
                        })
                        .map(team => (
                            <tr key={team.id}>
                                <td>
                                    <Link
                                        to={`/league-management/looking-for-players/${team.id}`}
                                    >
                                        edit or delete
                                    </Link>
                                </td>
                                <td>{team.team}</td>
                                <td>{team.age?.join(", ")}</td>
                                <td>{team.position?.join(", ")}</td>
                                <td>{team.description || "-"}</td>
                                <td>
                                    <b>{team.contactName}</b>
                                    <br />
                                    <a href={`mailto: ${team.contactEmail}`}>
                                        {team.contactEmail}
                                    </a>
                                    <br />
                                    {team.contactNumber}
                                    <br />
                                    {team.contactSite && (
                                        <a href={team.contactSite}>
                                            visit website
                                        </a>
                                    )}
                                </td>
                            </tr>
                        ))}
                </tbody>
            </Table>
        </div>
    ) : (
        <Outlet
            context={{
                setLookingList: setLookingList,
                looking: loadedList.find(
                    t => params.teamId && t.id === parseInt(params.teamId),
                ),
            }}
        />
    );
};

export default LookingForPlayers;
